import {delegateEvent} from "../utils/event.delegator";
import ContentTilesView from 'js/views/content.tiles.view';
import NavBarView from 'js/views/navbar.view';
import ContentFileUploadView from 'js/views/contentfileupload.view';
import {Backbone} from "backboneAdapter";

require('metroHelpers');

$.ajaxSetup({
    error: function (jqXHR) {
        $.Notify.error('Error ' + jqXHR.status);
    }
});

export default Backbone.Router.extend({
    routes: {
        "": "defaultRoute"
    },
    initialize: function () {
        console.info("Initializing Content Router");
        this.navbar = new NavBarView();
        this.contentTilesView = new ContentTilesView({});
        this.contentFileUploadView = new ContentFileUploadView({
            el: ".optional-upload-view",
            dropZone: 'body',
            model: new Backbone.Model({
                uploadUrl: "/CampaignCloud/Content/UploadContent"
            }),
            inVoucherConfiguration: false
        });
        delegateEvent(this.contentFileUploadView, this.contentTilesView, "uploaded:content")
    },
    defaultRoute: function () {
        console.info("defaultRoute");
    }
});
    